import { InjectionToken, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { TUI_ENGLISH_LANGUAGE } from '@taiga-ui/i18n/languages';
import { of } from 'rxjs';

const TUI_LANGUAGE = new InjectionToken(`Language for Taiga UI libraries i18n`, {
    factory: () => of(TUI_ENGLISH_LANGUAGE),
});

function extractI18n(key) {
    return () => inject(TUI_LANGUAGE).pipe(map(lang => lang[key]));
}

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_LANGUAGE, extractI18n };

